import './LocationProfile.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Icon from 'components/Icon';

import cxHelpers from 'util/className';

import LocationProfileRows from '../LocationProfileRows';

@cxHelpers('LocationProfile')
export default class LocationProfile extends PureComponent {
  static propTypes = {
    locationProfile: PropTypes.instanceOf(Map).isRequired,
    jobRequests: PropTypes.instanceOf(Map).isRequired,
  };

  render() {
    const { locationProfile, jobRequests } = this.props;

    return (
      <Box className={this.cx()}>
        <Box mbxxs phm>
          <Box vcenter spacebetween>
            <h4 className="mbn">{locationProfile.get('title')}</h4>
            <Box className={this.cxEl('address')}>
              <Icon type="mapMarker" className={this.cxEl('icon')} />
              {locationProfile.get('full_street_address')}
            </Box>
          </Box>
        </Box>

        <Box phs>
          <hr />
        </Box>

        <LocationProfileRows
          locationProfile={locationProfile}
          jobRequests={jobRequests}
        />
      </Box>
    );
  }
}
